
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppDefaultSettings from "@/components/sales/SaleEditSaveModalDefaultSettings.vue";
import AppTotalBox from "@/components/sales/SaleEditSaveModalTotalBox.vue";
import AppSelectSaleLayout from "@/components/SelectSaleLayout.vue";
import { Sale } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import { HttpError } from "../../utils/services/http-error";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		sale():Sale {
			return this.state.doc.Sale as Sale;
		}
	},
	async mounted() {
		if (this.sale.ExpirationDate.getTime() == 0) {
			this.sale.ExpirationDate = new Date(this.sale.InvoiceDate.getTime());
			if (!this.sale.Contact) return;
			this.sale.ExpirationDate.setDate(this.sale.ExpirationDate.getDate() + this.sale.Contact.PaymentDays);
			if (this.sale.Contact.PaymentEndMonth) {
				this.sale.ExpirationDate = new Date(this.sale.ExpirationDate.getFullYear(), this.sale.ExpirationDate.getMonth() + 1, 0);
			}
		}
		try {
			if (this.sale.LayoutID == 0) {
				let saleConfig = DossierConfigService.getSaleConfig(this.state.doc.SaleTypeID);

				if (saleConfig.DefaultLayoutID > 0) {
					this.sale.LayoutID = saleConfig.DefaultLayoutID;
				}
			}
		} catch (err) {
			let error = err as HttpError;
			if (error.status == 404) {
				this.sale.LayoutID = 0;
			}
		}
	},
	components: {
		AppDefaultSettings,
		AppTotalBox,
		AppCustomLanguageSelect,
		AppSelectSaleLayout
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
